import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { PlannerContext } from "../../../context/planner/PlannerContext";
import { calculateBlockHeight } from "../../../helpers/planner/calculateBlockHeight";
import { isLightColor } from "../../../helpers/colorUtils";

const TimeBlock = ({ block, isSelected = false, onClick, isPast = false }) => {
  const { name, startTime, endTime, color } = block;
  const { timeToMinutes } = useContext(PlannerContext);

  const handleClick = isPast ? undefined : onClick;
  const blockHeight = calculateBlockHeight(startTime, endTime, timeToMinutes);

  // Determine if we need dark text for light backgrounds
  const textColor = color && isLightColor(color) ? "#333333" : "white";

  return (
    <Box
      className={`block time-block ${isSelected ? "block--selected" : ""} ${isPast ? "block--past" : ""}`}
      onClick={handleClick}
      sx={{
        ...(isPast ? { cursor: "default" } : {}),
        height: `${blockHeight}px`,
        ...(color && {
          background: color,
          backgroundImage: "none",
        }),
      }}
    >
      <Box className="block_title-time-wrapper">
        <Typography
          variant="body1"
          className="block_title"
          sx={{ color: textColor }}
        >
          {name || "Time Block"}
        </Typography>
        <Box className="block_time-badge">
          <Typography
            variant="caption"
            className="block_time-badge-text"
            sx={{ color: textColor }}
          >
            {startTime} — {endTime}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TimeBlock;
